import { createContext } from "react";

const DF_OT0022Context = createContext();

export { DF_OT0022Context };